import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import Can from "../../components/can";
import {
  fetchOrganizationTerms,
  fetchOrganizationCurrentTerms,
} from "../../redux/organization/actions";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { Paper } from "@material-ui/core";
import format from "date-fns/format";

const languageLabel = (code) => ((code || "pl").toLowerCase() === "en" ? "EN" : "PL");

const OrganizationTerms = ({ organization, terms, fetchOrganizationTerms }) => {
  const orgCurrentTerms = useSelector((s) => s.orgCurrentTerms);
  const fetchingOrgCurrentTerms = useSelector((s) => s.fetchingOrgCurrentTerms);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchOrganizationTerms();
  }, [organization]);

  useEffect(() => {
    !orgCurrentTerms &&
      organization &&
      !fetchingOrgCurrentTerms &&
      dispatch(fetchOrganizationCurrentTerms(organization.id));
  }, [organization?.id]);

  const page = () => (
    <Grid container direction="column">
      <Box>
        <Typography variant="h6" gutterBottom>
          Zarządzanie regulaminami
        </Typography>
      </Box>

      <hr />

      <Grid item lg={12} xl={8}>
        <Typography variant="body2" color="textSecondary">
          Dodawanie i usuwanie regulaminów (wraz z wariantami językowymi) odbywa
          się w panelu super-administratora. Poniżej znajduje się lista
          obowiązujących regulaminów.
        </Typography>
      </Grid>
      <hr />
      <Grid item xs={12}>
        <Typography variant="subtitle1" component="h1">
          Lista regulaminów
        </Typography>
        <br />
        <TableContainer component={Paper}>
          <Table aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="right">Nazwa</TableCell>
                <TableCell align="right">Język</TableCell>
                <TableCell align="right">Aktywny od</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {terms
                .filter((term) => term.removedAt == null)
                .sort(
                  (t1, t2) =>
                    new Date(t2.activeSince).getTime() -
                    new Date(t1.activeSince).getTime()
                )
                .map((term, index) => (
                  <TableRow
                    key={index}
                    style={
                      orgCurrentTerms?.id === term.id
                        ? { border: "solid" }
                        : null
                    }
                  >
                    <TableCell align="right">
                      {term.name}{" "}
                      <a href={`/org-media/files${term.link}`} target={"_blank"} rel="noreferrer">
                        (podgląd)
                      </a>
                    </TableCell>
                    <TableCell align="right">
                      {languageLabel(term.language)}
                    </TableCell>
                    <TableCell align="right">
                      {term.activeSince
                        ? format(new Date(term.activeSince), "yyyy-MM-dd")
                        : ""}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );

  const redirect = () => <Redirect to="/login" />;

  return <Can permission="terms-page:view" ok={page} not={redirect} />;
};

const mapStateToProps = (state) => ({
  terms: state.terms,
  organization: state.organization,
});

const mapDispatchToProps = (dispatch) => ({
  fetchOrganizationTerms: () => dispatch(fetchOrganizationTerms()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationTerms);
